<script lang="ts">
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../_common/z/zinput.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import { PaymentMethodTypeEnum, type PaymentMethod, PaymentMethodTypeFriendlyEnum } from '../../modules/posApi/payment-methods/payment-methods'

    export let method: PaymentMethod

    // opção vazia explícita: sem ela o select fica sem seleção visível enquanto o tipo está vazio
    const typeOptions = [
        { value: '', label: '' },
        ...Object.keys(PaymentMethodTypeEnum).map((key) => ({ value: key, label: PaymentMethodTypeFriendlyEnum[key] })),
    ]
    const installmentsOptions = Array.from({ length: 60 }, (_, index) => ({ value: index + 1, label: String(index + 1) }))

    function removeItem() {
        method = null
    }

    function onTypeChange() {
        if (method.paymentMethodId) return
        if (method.type === PaymentMethodTypeEnum.bankslip) {
            method.receiptInterval = 30
            method.receiptDelay = 1
            method.receiptType = 'installment'
            method.billIntegration = true
            method.installments = 6
            return
        }
        if (method.type === PaymentMethodTypeEnum.money) {
            method.receiptInterval = 0
            method.receiptDelay = 0
            method.receiptType = 'full'
            method.billIntegration = false
            method.installments = 1
            return
        }
        if (method.type === PaymentMethodTypeEnum.check) {
            method.receiptInterval = 30
            method.receiptDelay = 1
            method.receiptType = 'installment'
            method.billIntegration = true
            method.installments = 6
            return
        }
        if (method.type === PaymentMethodTypeEnum.credit) {
            method.receiptInterval = 30
            method.receiptDelay = 30
            method.receiptType = 'installment'
            method.billIntegration = false
            method.installments = 12
            return
        }
        if (method.type === PaymentMethodTypeEnum.debit) {
            method.receiptInterval = 1
            method.receiptDelay = 0
            method.receiptType = 'full'
            method.billIntegration = false
            method.installments = 1
            return
        }
        if (method.type === PaymentMethodTypeEnum.pix) {
            method.receiptInterval = 0
            method.receiptDelay = 0
            method.receiptType = 'full'
            method.billIntegration = false
            method.installments = 1
            return
        }
        if (method.type === PaymentMethodTypeEnum.recurring) {
            method.receiptInterval = 30
            method.receiptDelay = 30
            method.receiptType = 'installment'
            method.billIntegration = true
            method.installments = 12
            return
        }
        method.receiptInterval = 0
        method.receiptDelay = 0
        method.receiptType = 'full'
        method.billIntegration = false
    }
</script>

{#if method}
    <ZContainer class="mt-2" gapRow="8px" gapCol="8px">
        <Zinput size={5} sizeM={12} label="Nome" type="text" bind:value={method.label} />
        <Zinput size={3} sizeM={12} label="Tipo" type="select" options={typeOptions} bind:value={method.type} on:change={onTypeChange} />
        <Zinput size={3} sizeM={12} label="Parcelamento máximo" type="select" options={installmentsOptions} bind:value={method.installments} />
        <ZContainerCol size={1} sizeM={12}>
            {#if !method.paymentMethodId}
                <Zbutton color="red" icon={faTrash} on:click={removeItem} />
            {/if}
        </ZContainerCol>
    </ZContainer>
{/if}
